/* ToolbarButton.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolbarButton.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import { cx } from '@atlaskit/css';
import { Pressable } from '@atlaskit/primitives/compiled';
import { useToolbarUI } from '../hooks/ui-context';
var styles = {
  button: "_zulp12x7 _2rko12b0 _11c82smr _1e0c1txw _bfhksm61 _o5721q9c _4cvr1h6o _1bah1h6o _1tke1f4h _syaz1gjq _19bvu2gc _u5f3u2gc _1ah3idpf _g0pbkb7n _oh03h2mm",
  enabled: "_irr3166n _1di61dty",
  disabled: "_syaz1lh4 _80om13gf",
  selected: "_bfhkfg4m _syazaqb7 _irr3i1yw _1di619ru"
};
export var ToolbarButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var iconBefore = _ref.iconBefore,
    children = _ref.children,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    ariaExpanded = _ref['aria-expanded'],
    ariaHasPopup = _ref['aria-haspopup'],
    ariaControls = _ref['aria-controls'],
    dataDsLevel = _ref['data-ds--level'],
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    testId = _ref.testId,
    isDisabled = _ref.isDisabled,
    ariaKeyshortcuts = _ref.ariaKeyshortcuts,
    label = _ref.label,
    interactionName = _ref.interactionName;
  var _useToolbarUI = useToolbarUI(),
    preventDefaultOnMouseDown = _useToolbarUI.preventDefaultOnMouseDown,
    ctxDisabled = _useToolbarUI.isDisabled;
  var disabled = Boolean(ctxDisabled || isDisabled);
  return /*#__PURE__*/React.createElement(Pressable, {
    ref: ref,
    xcss: cx(styles.button, disabled ? styles.disabled : isSelected ? styles.selected : styles.enabled),
    "aria-pressed": isSelected,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHasPopup,
    "aria-controls": ariaControls,
    "aria-keyshortcuts": ariaKeyshortcuts,
    "aria-label": label,
    "data-ds--level": dataDsLevel,
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    testId: testId,
    isDisabled: disabled,
    onMouseDown: function onMouseDown(event) {
      if (preventDefaultOnMouseDown) {
        event.preventDefault();
      }
    },
    "data-toolbar-component": "button",
    interactionName: interactionName
  }, iconBefore, children);
});